import SpzLogo from "@/assets/logo-spz.svg";
import { reportsConfig } from "@spz/config";
import { Typography } from "@spz/ui/components/typography";
import { useTranslation } from "react-i18next";

export const ReportExpiredPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="h-screen">
      <div className="flex items-center justify-center h-full bg-gray-50 rounded-md overflow-auto">
        <div className="flex flex-col w-full max-w-[534px] mx-6 gap-6">
          <div>
            <img src={SpzLogo} alt="SpzLogo" className="w-[172px]" />
          </div>
          <div className="gap-2">
            <Typography variant="h3">{t("report_expired_title")}</Typography>

            <Typography className="text-gray-700 text-subtitle">
              {t("report_expired_description", {
                days: reportsConfig.reportRetentionDays,
              })}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportExpiredPage;
